<template>
    <div class="column-wrap module-wrap" :id="target" v-if="has_data" :data-spm="spm">
        <h3 class="tt">{{param.tag}}</h3>
        <template v-if="param.newsStreamType === 2">
            <div class="news-list">
                <template v-for="feed in show_mp_list">
                    <feed-item :feed="feed"></feed-item>
                </template>
                <footer class="more" @click="loadMore" v-show="!load_all"><div>查看更多</div><i class="ico icon-fold"></i></footer>
            </div>
        </template>
        <template v-else-if="param.newsStreamType === 0">
            <div class="news-list">
                <template v-for="feed in show_custom_list">
                    <feed-item :feed="feed"></feed-item>
                </template>
                <footer class="more" @click="showMore" v-show="has_more_show"><div>查看更多</div><i class="ico icon-fold"></i></footer>
            </div>
        </template>
        <template v-if="param.newsStreamType === 3">
            <div class="news-list">
                <template v-for="feed in show_operate_list">
                    <feed-item :feed="feed"></feed-item>
                </template>
                <footer class="more" @click="loadOperate" v-show="!load_operate_all"><div>查看更多</div><i class="ico icon-fold"></i></footer>
            </div>
        </template>
    </div>
</template>
<script>
import axios from 'axios';
import FeedItem from './feed-item.vue';
import feedHelper from './helper/feed';
import getInfo from './helper/getCookie';
export default {
    props: {
        target: {
            default: '',
            type: String
        },
        spm:{
            default: '',
            type: String
        },
        param : {
            default : {},
            type: Object
        },
        findex: {
            default: '',
            type: [ String, Number ]
        }
    },
    data(){
        return {
            page_no: 1,
            page_size: 5,
            pre_mp_fetch: [],
            pre_operate_fetch:[],
            pre_custom: [],
            pre_operate_fetch:[],
            firstLoadNumber : 5,
            load_all: false,
            load_operate_all: false
        }
    },
    created(){
        let newsStreamType = this.param.newsStreamType;

        if(this.param.firstLoadNumber > 0){
            this.firstLoadNumber = this.param.firstLoadNumber;
        }
        switch(newsStreamType){
            case 2:
                this.initMpFetchData();
                break;
            case 3:
                this.initOperateData();
                break;
            default:
                this.initCustomData();

        }
    },
    mounted(){
        this.initStatistics();
    },
    updated(){
        this.initStatistics();
        this.$nextTick(function(){
            //触发统计sdk的埋点
            if(window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
                window.sohuSpm.domDidChange();
            };
        })
    },
    methods: {
        initStatistics(){
            // need Optimization
            this.$nextTick(() => {
                let feedList, container = document.getElementById(this.target);
                if(container){
                    feedList = container.querySelectorAll('a[data-log-content-ev]');
                    this.$emit('mounted', feedList);
                }
            }); 
        },
        initCustomData(){
            this.pre_custom = this.param.data;
        },
        showMore(){
           this.page_no++;
        },
        loadMore(){
            this.page_no++;
            this.fetchData({
                 load_num: this.firstLoadNumber
            }, (data) => {
                this.pre_mp_fetch = this.pre_mp_fetch.concat(data);
            });
        },
         loadOperate(){
            this.page_no++;
            this.fetchOperateData({
                load_num: this.firstLoadNumber
            }, (data) => {
                 for(var i =0; i < data.data.length; i++){
                    if(data.data[i].images[0]){
                         this.pre_operate_fetch = this.pre_operate_fetch.concat(data.data[i]);
                    }
                }  
            });
        },
        initMpFetchData(sucFun){
            this.fetchData({
                load_num: this.firstLoadNumber
            }, (data) => {
                this.pre_mp_fetch = data;
            })
        },
        initOperateData(){
            this.fetchOperateData({
               load_num: this.firstLoadNumber 
            },(data)=>{
                for(var i =0; i < data.data.length; i++){
                    if(data.data[i].images[0]){
                        this.pre_operate_fetch.push(data.data[i]);
                    }
                }
                
            })
        },
        fetchData(opt, sucFun){
            let reqNum ;
            let that = this;
            let newsStreamParam = this.param.newsStream[0];
            let reqUrl = `//v2.sohu.com/public-api/authors/${newsStreamParam.passportId}/articles`;
           
            if(opt && opt.load_num > 0){
                reqNum = opt.load_num;
            }else{
                reqNum = this.page_size;
            }
            let reqParam = {
                    page : that.page_no,
                    size: reqNum,
                    startTimeInMilliSecond: newsStreamParam.startTime
                }
            axios.get(reqUrl, {
                params: reqParam
            }).then(function(response) {
                if(response.status === 200){
                    if(response.data.length < reqNum){
                        that.load_all = true;
                    }
                    if(typeof sucFun === 'function') sucFun(response.data);
                }
            }).catch(function(err) {
                console.warn(err);
            });
        },
        fetchOperateData(opt, sucFun){
            let that = this;
            let regionId = this.param.newsStream[0] && this.param.newsStream[0].regionId;
            if(regionId) {
                let baseUrl = `//v2.sohu.com/integration-api/mix/region/${regionId}`;
                let reqNum;
                let SUV = getInfo.getCookie('SUV')
                let pvId = getInfo.generateRand();
                if (window.sohuSpm && typeof window.sohuSpm.getCodes === 'function') {
                    pvId = window.sohuSpm.getCodes().e
                }
                if(opt && opt.load_num > 0){
                    reqNum = opt.load_num;
                }else{
                    reqNum = this.page_size;
                }
                let reqParam1 = {
                    size: reqNum,
                    adapter : 'adapter1',
                    page : that.page_no,
                    pvId : pvId,
                    requestId : `${SUV}_${new Date().getTime()}`
                }
                axios.get(baseUrl, {
                    params: reqParam1
                }).then(function(response) {
                    if(response.status === 200){
                        if(response.data.data.length < reqNum){
                            that.load_operate_all = true;
                        }
                        if(typeof sucFun === 'function') sucFun(response.data);
                    }
                }).catch(function(err) {
                    console.warn(err);
                });
            }
        }
    },
    computed:{
        mp_list(){
            return feedHelper.formatFeedList(this.pre_mp_fetch, this.stat_flag, this.param.newsStreamType);
        },
        show_mp_list(){
            return this.mp_list.slice(0, this.show_num);
        },
        custom_list(){
            return feedHelper.formatFeedList(this.pre_custom, this.stat_flag, this.param.newsStreamType);
        },
        show_custom_list(){
            return this.custom_list.slice(0, this.show_num);
        },
        operate_list(){
             return feedHelper.formatFeedList(this.pre_operate_fetch, this.stat_flag, this.param.newsStreamType);
        },
        show_operate_list(){
            return this.operate_list.slice(0, this.show_num);
        },
        has_more_show(){
            return this.custom_list.length > this.show_num;
        },
        has_more_show_operate(){
            return this.operate_list.length > this.show_num;
        },
        show_num(){
            return (this.page_no - 1) * this.page_size + this.firstLoadNumber;
        },
        has_data(){
            return !!(this.mp_list.length > 0 || this.custom_list.length > 0 || this.operate_list.length > 0)
        },
        stat_flag(){
            let subId = window.subData.id;
            return `m-${subId}_subfeeds_${this.findex}`;
        }     
    },
    components: {
        FeedItem
    }
}
</script>
<style lang="less">
    .column-wrap{
        margin: 0 13px 10px 13px;
        padding: 14px 0 10px 0;
        border-bottom: 1px solid #f5f5f5;/*no*/
        .tt{
            font-size: 17px;/*no*/
            color:#222222;
            font-weight: bold;
        }
        .news-list{
            .feed-item:last-of-type{
                border: none;
            }
            .more{
                padding-top: 8px;
                padding-bottom: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;/*no*/
                color: #999;
                .ico{
                    font-size: 14px;/*no*/
                }
            }
            .no-data{
                line-height: 74px;
                color: #999;
            }
        } 
    }
</style>




// WEBPACK FOOTER //
// src/components/Column.vue